import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0, // یک بار بیشتر ری‌تلاش در صورت شکست برای پایداری بالاتر
      retryDelay: 0,
      refetchOnWindowFocus: false, // در پروژه‌هایی با نقش‌ها و UI زیاد، بازگشت به تب نباید درخواست اضافی بفرسته
      refetchOnReconnect: true, // وقتی اینترنت قطع و وصل می‌شه، اطلاعات تازه می‌گیره
      staleTime: 0, // بیشتر داده‌ها ۳ دقیقه تازه در نظر گرفته می‌شن
      cacheTime: 0, // حتی اگه کامپوننت unmount بشه، کش تا ۱۰ دقیقه نگه‌داری می‌شه
    refetchOnMount: 'always',
    },
    mutations: {
      retry: 0, // درخواست‌های تغییر اطلاعات فقط یک‌بار انجام می‌شن؛ شکست بخوره، مسئولیتش با کاربره
    },
  },
});

export default queryClient;
